// src/app/shared/tokens.ts

import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
export const ERP_ID_PARENT = new InjectionToken<number>('ERP_ID_PARENT');
export const IS_CUSTOMER_NO = new InjectionToken<boolean>('IS_CUSTOMER_NO');
